import { isNullOrUndefined } from 'util';
import { Subscriber, Subscription, Subject, ObjectUnsubscribedError } from "rxjs";




export enum ResultStatus
{
    Success=0,
    ApplicationError=1,
    HttpError=2
}

export class ServiceResult<T>
{
    status : ResultStatus;
    errorObject:string;
    result: T;

    static successResult<T>(val:T) : ServiceResult<T>
    {
        // if (isNullOrUndefined(val))
        // {
        //     throw new Error("Cannot create a success result of value undefined or null");
        // }
        return new ServiceResult(ResultStatus.Success, val);
    }


    static fromHttpError<T>(httpErr:any) : ServiceResult<T>
    {
        return new ServiceResult(ResultStatus.HttpError, null, httpErr);
    }

    static fromAppError<T>(err:any) : ServiceResult<T>
    {
        return new ServiceResult(ResultStatus.ApplicationError, null, err);
    }

   
    /*
     * Convert the result to something else keeping the status and error object intact
    */
    mapResult<R>(resultMapFn: (result:T)=>R) : ServiceResult<R>
    {
        let ret = new ServiceResult<R>();
        ret.errorObject = this.errorObject;
        ret.status = this.status;
        ret.result = this.result == null?null: resultMapFn(this.result);
        return ret;
    }
    
    public constructor(status?:ResultStatus,val?:T, err?:any)
    {
        this.status = status;
        this.result = val;        
        this.errorObject = err;
    }
}


